import { ensureUserTokenResponse } from "./tokens/user-token-response";
import { requireConfigValue } from "../isomorphic-config";
const createEmptyWishlist = (fetch)=>{
    const defaultImagesSize = requireConfigValue("imagesSize");
    const defaultImagesQuality = requireConfigValue("imagesQuality");
    const token = ensureUserTokenResponse();
    const params = {
        include: [
            "wished_items",
            "wished_items.variant",
            "wished_items.variant.product",
            "wished_items.variant.product.primary_variant",
            "wished_items.variant.product.images",
            "wished_items.variant.product.option_types",
            "wished_items.variant.product.variants",
            "wished_items.variant.product.variants.option_values",
            "wished_items.diamond", 
        ].join(","),
        image_transformation: {
            quality: defaultImagesQuality,
            size: "600x600" || defaultImagesSize
        }
    };
    if (token) {
        return fetch({
            variables: {
                methodPath: "wishlists.default",
                arguments: [
                    token,
                    params
                ]
            }
        });
    } else {
        const createWishlistParameters = {
            name: "Guest Wishlist",
            is_private: false,
            is_default: false
        };
        return fetch({
            variables: {
                methodPath: "wishlists.create",
                arguments: [
                    createWishlistParameters,
                    params
                ]
            }
        });
    }
};
export default createEmptyWishlist;
